import React from "react"
import {
    CSpinner,
    CRow,
    CCol,
    CFormLabel,
    CFormSelect} from '@coreui/react'
import {
    cilCloudDownload, cilSearch} from '@coreui/icons'
import AppButton from 'src/components/AppButton'
import ServerConnector from 'src/ServerConnector'
import PageHeader from "src/components/PageHeader"
import DatePicker from "react-date-picker"
import { getDBDate } from "src/util/DateUtil"
import { CChart } from "@coreui/react-chartjs"

const colors = [
    'rgb(255,160,122)',
    'rgb(255,215,0)',
    'rgb(50,205,50)',
    'rgb(32,178,170)',
    'rgb(70,130,180)',
    'rgb(186,85,211)',
    'rgb(219,112,147)',
    'rgb(250,235,215)',
    'rgb(119,136,153)',
    'rgb(205,133,63)',
    'rgb(165,42,42)',
    'rgb(47,79,79)',
    'rgb(199,21,133)',
    'rgb(75,0,130)',
    'rgb(72,61,139)',
    'rgb(0,128,128)',
    'rgb(107,142,35)',
    'rgb(255,0,0)',
];

export default class DoubtsSummaryReport extends React.Component {
    constructor(props) {
        super(props);

        var today = new Date();

        this.state = {
            spinner: false,
            reportData: [],
            labelsData: [],
            classData: [],
            fromDate: new Date(today.getFullYear()-1, today.getMonth(), today.getDate()),
            toDate: today,
            selectedClass: "",
            classList: []
        };
    }
    componentDidMount() {
        this.loaddata('REPORT');
        this.loadStudentClass();
    }

    loaddata(format) {

        this.setState({
            spinner: true
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_DOUBTS_SUMMARY_REPORT",
            "format": format,
            "from_date": getDBDate(this.state.fromDate),
            "to_date": getDBDate(this.state.toDate),
        }

        if (this.state.selectedClass.length > 0) {
            dataMap["class"] = this.state.selectedClass;
        }

        connector.postData(dataMap, (data) => { // success

            if (format == "REPORT") {

                var labelsData = [];
                var uniqueClasses = [];
                var classValue = {};
                for (var i=0;i<data.data.length;i++) {
                    labelsData.push(data.data[i].subject);

                    classValue[data.data[i].subject] = {};

                    for (var j=0;j<data.data[i].class_data.length;j++) {

                        classValue[data.data[i].subject][data.data[i].class_data[j].class] = data.data[i].class_data[j].count;
                        if (!uniqueClasses.includes(data.data[i].class_data[j].class)) {
                            uniqueClasses.push(data.data[i].class_data[j].class);
                        }
                    }
                }

                var classData = [];
                for (var i=0;i<uniqueClasses.length;i++) {

                    var valueData = [];
                    for (var j=0;j<labelsData.length;j++) {

                        var countValue = 0;
                        if (classValue[labelsData[j]]) {

                            if (classValue[labelsData[j]][uniqueClasses[i]]) {

                                countValue = classValue[labelsData[j]][uniqueClasses[i]];
                            }
                        }
                        valueData.push(countValue);
                    }
                    
                    var color = colors[colors.length-1];
                    if (colors[i]) {
                        color = colors[i];
                    }

                    classData.push({
                        label: uniqueClasses[i],
                        data: valueData,
                        backgroundColor: color,
                        maxBarThickness: 72
                    });
                }

                this.setState({
                    spinner: false,
                    reportData: data.data,
                    labelsData: labelsData,
                    classData: classData
                });
            }
            else {
                this.setState({
                    spinner: false,
                });

                window.open(data.data[0].file_path, '_blank', 'noreferrer');
            }
        }, (err_cd, msg, data) => { // failure

            if (format == "REPORT") {
                this.setState({
                    spinner: false,
                    reportData: [],
                    labelsData: [],
                    classData: [],
                });
            }
            else {
                this.setState({
                    spinner: false,
                });
            }
        })
    }

    loadStudentClass() {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_CLASSES",
        }

        connector.postData(dataMap, (data) => { // success

            this.setState({classList: data.data});
            
        }, (err_cd, msg, data) => { // failure

            this.setState({classList: []});
        })
    }

    handleExportXls() {

        this.loaddata('XLS');
    }

    updateInput(key, value) {

        this.setState({
            [key]: value
        });
    }

    render() {

        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Export To XLS"
                        icon={cilCloudDownload}
                        isLoading={false}
                        onClick={() => this.handleExportXls()} />
                </PageHeader>
                <CRow>
                    <CCol md="3">
                        <CFormLabel style={{marginRight: 5, fontWeight: 'bold'}}>Start Date:</CFormLabel>
                        <DatePicker 
                            onChange={(value) => this.updateInput("fromDate", value)} 
                            value={this.state.fromDate}
                            format="dd/MM/y"
                            dayPlaceholder="dd"
                            monthPlaceholder="MM"
                            yearPlaceholder="yyyy"
                            showLeadingZeros={true}
                            clearIcon={null}
                            maxDate={new Date()} />
                    </CCol>
                    <CCol md="3">
                        <CFormLabel style={{marginRight: 5, fontWeight: 'bold'}}>End Date:</CFormLabel>
                        <DatePicker 
                            onChange={(value) => this.updateInput("toDate", value)} 
                            value={this.state.toDate}
                            format="dd/MM/y"
                            dayPlaceholder="dd"
                            monthPlaceholder="MM"
                            yearPlaceholder="yyyy"
                            showLeadingZeros={true}
                            clearIcon={null}
                            maxDate={new Date()} />
                    </CCol>
                    <CCol md="3">
                        <CFormSelect size="sm" value={this.state.selected_top_seq} onChange={(event) => { this.updateInput("selectedClass", event.target.value) }}>
                            <option value="">Student Class</option>
                            {
                                this.state.classList.map((object, index) => {
                                    return (
                                        <option key={String(index)}
                                            value={object.value}>{object.display}
                                        </option>
                                    )
                                })
                            }
                        </CFormSelect>
                    </CCol>
                    <CCol md="3">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loaddata('REPORT'); }} />
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                
                <CChart
                    type="bar"
                    style={{marginRight: 48, marginLeft: 48}}
                    options={{
                        scales: {
                            x: {
                                stacked: true,
                            },
                            y: {
                                stacked: true,
                            },
                        },
                    }}
                    data={{
                        labels: this.state.labelsData,
                        datasets: this.state.classData,
                    }}
                />
            </>
        );
    }
}